import { Stack, Typography } from '@mui/material';
import ModalComponent from 'src/components/Modal/ModalComponent';

const PopupContactSales = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
  return (
    <ModalComponent
      padding={4}
      open={open}
      handleClose={() => {
        handleClose();
      }}
      showCloseIcon={true}
    >
      <Stack direction="column" spacing={2} alignItems="center" width={504}>
        <Typography textAlign="center" variant="h5">
          Contact Sales
        </Typography>
        <Typography textAlign="center" variant="body1">
          Please contact us to get more information about the <b>Enterprise</b> plan via email{' '}
          <a target="_blank" rel="noopener noreferrer" href="mailto:g.funaro@icttm.org">
            g.funaro@icttm.org
          </a>
          .
        </Typography>
        <Typography textAlign="center" variant="body1" color="text.secondary">
          We will get back to you as soon as possible.
        </Typography>
      </Stack>
    </ModalComponent>
  );
};

export default PopupContactSales;
